<template>
  <div class="mains">
    <div class="campus">功能模块 <span>></span> 趣配音作品</div>
    <div class="pane">
      <el-form inline size="small">
        <el-form-item label="机构">
          <el-input v-model="query.orgName"/>
        </el-form-item>
        <el-form-item label="用户">
          <el-input v-model="query.userName"/>
        </el-form-item>
        <el-form-item label="教材">
          <el-input v-model="query.bookName"/>
        </el-form-item>
        <el-form-item label="章节">
          <el-input v-model="query.chapterTitle"/>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.statusLabel" clearable placeholder="全部">
            <el-option label="已生成" value="已生成"/>
            <el-option label="草稿" value="草稿"/>
            <el-option label="制作中" value="制作中"/>
            <el-option label="失败" value="失败"/>
          </el-select>
        </el-form-item>
        <el-button type="primary" size="small" @click="load(1)">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </el-form>
      <el-table :data="rows" border>
        <el-table-column prop="title" label="作品名称"/>
        <el-table-column label="教材章节">
          <template slot-scope="scope">{{ scope.row.bookName || '—' }} / {{ scope.row.chapterTitle || '—' }}</template>
        </el-table-column>
        <el-table-column prop="userName" label="配音用户"/>
        <el-table-column prop="orgName" label="机构"/>
        <el-table-column prop="submitAt" label="时间"/>
        <el-table-column prop="statusLabel" label="状态" width="100"/>
        <el-table-column label="操作" width="140">
          <template slot-scope="scope">
            <el-button v-if="scope.row.rowKind !== 'TASK'" type="text" @click="open(scope.row)">查看</el-button>
            <el-button v-if="scope.row.rowKind !== 'TASK'" type="text" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :current-page="page" :page-size="20" :total="total"
                     @current-change="load"/>
    </div>
    <el-dialog :visible.sync="show" title="作品详情" width="720px">
      <div v-if="current">
        <p>{{ current.userName }} · {{ current.orgName }} · {{ current.bookName }} / {{ current.chapterTitle }}</p>
        <p v-if="current.isPartial">未完整配音 {{ current.recordedCount }}/{{ current.totalCount }}</p>
        <video v-if="current.videoUrl" :src="current.videoUrl" controls class="player"/>
        <div v-else-if="current.videoFileId">成品在本机目录，点下面的录音同样方式试听视频。</div>
        <el-button v-if="current.videoFileId && !current.videoUrl" size="mini" @click="play(current.videoFileId, true)">
          播放成品
        </el-button>
        <el-table :data="current.lines || []" border>
          <el-table-column prop="order" label="句" width="60"/>
          <el-table-column prop="textEn" label="台词"/>
          <el-table-column label="总分" width="90">
            <template slot-scope="scope">
              <el-button type="text" @click="scope.row.open = !scope.row.open">{{ scoreText(scope.row) }}</el-button>
              <div v-if="scope.row.open">流畅 {{ dim(scope.row.fluencyScore) }} / 准确 {{
                  dim(scope.row.accuracyScore)
                }} / 完整 {{ dim(scope.row.integrityScore) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="录音" width="80">
            <template slot-scope="scope">
              <el-button v-if="scope.row.audioFileId" type="text" @click="play(scope.row.audioFileId)">试听</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/** 作品、草稿和制作中查询，以及删除。 */
const empty = () => ({orgName: '', userName: '', bookName: '', chapterTitle: '', statusLabel: ''});
export default {
  name: 'dubbingWorks',
  data() {
    return {query: empty(), rows: [], total: 0, page: 1, show: false, current: null, audio: null};
  },
  created() {
    this.load(1);
  },
  beforeDestroy() {
    if (this.audio) this.audio.pause();
  },
  methods: {
    auth() {
      return {Authorization: 'Bearer ' + window.sessionStorage.getItem('userinfo').replace(/"/g, '')};
    },
    load(page) {
      this.page = page;
      this.$http({
        url: '/edu/dubbing/works',
        method: 'GET',
        headers: this.auth(),
        params: {...this.query, page, pageSize: 20}
      })
        .then((res) => {
          if (res.data.code !== 0) return this.$message.error(res.data.message);
          this.rows = res.data.data.records || [];
          this.total = res.data.data.total || 0;
        });
    },
    reset() {
      this.query = empty();
      this.load(1);
    },
    open(row) {
      this.$http({
        url: '/edu/dubbing/works/' + row.rowId,
        method: 'GET',
        headers: this.auth(),
        params: {kind: row.rowKind}
      })
        .then((res) => {
          if (res.data.code !== 0) return this.$message.error(res.data.message);
          this.current = res.data.data;
          (this.current.lines || []).forEach((line) => {
            this.$set(line, 'open', false);
          });
          this.show = true;
        });
    },
    // 删除前再确认一次。草稿只改状态。
    remove(row) {
      this.$confirm('删除后不可恢复', '删除').then(() => {
        const url = row.rowKind === 'DRAFT' ? '/edu/dubbing/drafts/' : '/edu/dubbing/works/';
        this.$http({url: url + row.rowId + '?confirmed=true', method: 'DELETE', headers: this.auth()}).then((res) => {
          if (res.data.code !== 0) return this.$message.error(res.data.message);
          this.$message.success(res.data.data.status === 'DELETING' ? '删除处理中' : '已删除');
          this.load(this.page);
        });
      }).catch(() => {
      });
    },
    play(fileId) {
      this.$http({
        url: '/edu/dubbing/files/' + fileId,
        method: 'GET',
        headers: this.auth(),
        responseType: 'blob'
      }).then((res) => {
        if (this.audio) this.audio.pause();
        const url = URL.createObjectURL(res.data);
        if (String(res.data.type).indexOf('video') === 0) {
          this.current.videoUrl = url;
          return;
        }
        this.audio = new Audio(url);
        this.audio.play();
      });
    },
    scoreText(row) {
      if (row.evaluationStatus && row.evaluationStatus !== 'SUCCESS') return row.evaluationStatus === 'REJECTED' ? '拒评' : '评分中';
      return row.score === null || row.score === undefined ? '暂无' : row.score;
    },
    // 缺的分项显示暂无，不从总分反算。
    dim(value) {
      return value === null || value === undefined ? '暂无' : value;
    },
  },
};
</script>

<style scoped>
.pane {
  background: #fff;
  padding: 16px;
}

.player {
  width: 100%;
  max-height: 280px;
  background: #111;
}
</style>
